module.exports = __webpack_public_path__ + "img/googleplay_2208x1242_06_TournamentsChallenges.f98a8d62.png";